import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { reportingLeLensPath } from '~/consts/reportingLeLensApi';

import type { LensResponse } from '~/types/leLens';

import { requestWithTimeout } from '~/utils/requestWithTimeout';
import { resolveReportingLeLensUrl } from '~/utils/resolveReportingLeLensUrl';

import { reportingLeLensQueryKeys } from './useGetReportingLeLens';

export function useSetLensDatasetDeleted() {
  const client = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  return useMutation({
    mutationFn: ({
      lensId,
      datasetId,
      ...body
    }: {
      lensId: string;
      datasetId: string;
      lensVersion: number;
      deleted: boolean;
    }) =>
      requestWithTimeout<LensResponse>(
        resolveReportingLeLensUrl(`${reportingLeLensPath(lensId)}/datasets/${encodeURIComponent(datasetId)}/deletion`),
        { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) },
        'The change was not confirmed. Reload the Lens.',
      ),
    onSuccess: async (_, input) => {
      await client.invalidateQueries({ queryKey: reportingLeLensQueryKeys.all });
      enqueueSnackbar(input.deleted ? 'Dataset deleted; linked cards retained' : 'Dataset restored', {
        variant: 'success',
      });
    },
    onError: (error: Error) => enqueueSnackbar(error.message, { variant: 'error' }),
    retry: false,
  });
}
